export const minuteInMillis = 60 * 1000;

export const hourInMillis = 60 * minuteInMillis;

export const dayInMillis = 24 * hourInMillis;

export const weekInMillis = 7 * dayInMillis;

// This line of code means that a month is equal to 30 days
// When a user submits for example 30 months, it won't be equivalent to 30 months
// This has been discussed with product and they say this is fine
// This comment is an insurance policy for the tech team ;)
export const monthInMillis = 30 * dayInMillis;

export const yearInMillis = 365 * dayInMillis;

export type IUnit = 'years' | 'months' | 'weeks' | 'days' | 'hours' | 'minutes';

export interface IDuration {
  value: number;
  unit: IUnit;
}

export const unitToMillis = (value: number, unit: IUnit) => {
  switch (unit) {
    case 'years':
      return value * yearInMillis;
    case 'months':
      return value * monthInMillis;
    case 'weeks':
      return value * weekInMillis;
    case 'days':
      return value * dayInMillis;
    case 'hours':
      return value * hourInMillis;
    case 'minutes':
      return value * minuteInMillis;
    default:
      // eslint-disable-next-line no-console
      console.log(`Invalid IDuration passed to unitToMillis: ${value} ${unit}`);
  }
};

export const millisToUnit = (value: number): IUnit => {
  const valueInDays = value / dayInMillis;
  const valueInHours = value / hourInMillis;
  if (valueInDays % 365 === 0) {
    return 'years';
  } else if (valueInDays % 30 === 0) {
    return 'months';
  } else if (valueInDays % 7 === 0) {
    return 'weeks';
  } else if (valueInDays % 1 === 0) {
    return 'days';
  } else if (valueInHours % 1 === 0) {
    return 'hours';
  } else {
    return 'minutes';
  }
};

export const millisToDuration = (value: number): IDuration => {
  const valueInDays = value / dayInMillis;
  const valueInHours = value / hourInMillis;
  if (valueInDays % 365 === 0) {
    return { value: Math.floor(valueInDays / 365), unit: 'years' };
  } else if (valueInDays % 30 === 0) {
    return { value: Math.floor(valueInDays / 30), unit: 'months' };
  } else if (valueInDays % 7 === 0) {
    return { value: Math.floor(valueInDays / 7), unit: 'weeks' };
  } else if (valueInDays % 1 === 0) {
    return { value: Math.floor(valueInDays), unit: 'days' };
  } else if (valueInHours % 1 === 0) {
    return { value: Math.floor(valueInHours), unit: 'hours' };
  } else {
    const valueInMinutes = value / minuteInMillis;
    return { value: Math.floor(valueInMinutes), unit: 'minutes' };
  }
};

export const millisToSpecificUnitValue = (value: number, unit: IUnit) => {
  switch (unit) {
    case 'years':
      return value / yearInMillis;
    case 'months':
      return value / monthInMillis;
    case 'weeks':
      return value / weekInMillis;
    case 'days':
      return value / dayInMillis;
    case 'hours':
      return value / hourInMillis;
    case 'minutes':
      return value / minuteInMillis;
  }
};
